import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axiosInstance from "../utils/axiosInstance";
import image from '../images/doc.png';
import './login.css';
import axios from 'axios'; 
import { useSearchParams } from "react-router-dom";

function Login({user, setUser}) {
  const API_URL = process.env.REACT_APP_ENV;
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const redirectURL = searchParams.get("redirectURL") ?? '/';

    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });

    const [error, setError] = useState(''); // State for displaying errors
    const [loading, setLoading] = useState(false); // State for showing loading status

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
          const res = await axiosInstance.post(`${API_URL}/login`, {
            email: formData.email,
            password: formData.password
          });
          console.log(res.data)
          const access_token = res.data.access_token;
          const refresh_token = res.data.refresh_token;
          localStorage.setItem("token", access_token);
          localStorage.setItem("refresh_token", refresh_token)

          // Get user info from /me
          const userRes = await axiosInstance.get(`${API_URL}/me`, {
            headers: {
              Authorization: `Bearer ${access_token}`,
            },
          });
      
          setUser(userRes.data); 
          navigate(redirectURL);
        } catch (err) {
          console.error("Login failed", err?.response?.data || err.message);
          setError("Invalid credentials");
        } finally {
          setLoading(false);
        }
      };

    return(
        <div className="bg-image">
        <div className = 'login-container'>
            <div className = 'signup-img'>
                <img src = {image} alt = 'signup-image'/>
            </div>
            <div className = 'login-box'>
                <h2>Login</h2>
                <form onSubmit={handleSubmit}>
                    <input
                        type="email"
                        name="email"
                        placeholder="Email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                    />
                    <input
                        type="password"
                        name="password"
                        placeholder="Password"
                        value={formData.password}
                        onChange={handleChange}
                        required
                    />
                    {error && <p style={{ color: 'red', marginBottom: '10px' }}>{error}</p>}
                    <button type="submit" disabled={loading}>
                            {loading ? 'Logging in...' : 'Log in'}
                        </button>
                </form>
                <p>Don't have an account? <Link to="/signup">Sign Up</Link></p>
            </div>
        </div>
        </div>
    )
}

export default Login;